import {DataSourceFilter} from '../../portfolio-creation/manualinvest/filters/data-source.filter';
import {LenderPassbookRecord} from '../../model/lender-passbook-record';
import { Injectable } from "@angular/core";

@Injectable()
export class TransactionTypeFilter extends DataSourceFilter {
    identifier(): string {
        return 'TransactionTypeFilter';
    }

    onFilterApplied(data: LenderPassbookRecord, query: any): boolean {
        return data.getDisplayableTransactionType() === query;
    }
}
